const analytics = {
  postAnalytics: {
    method: "POST",
    path: "/analytics",
  },
  getSummary: {
    method: "GET",
    path: "/analytics/summary",
  },
  getAnalytics: {
    method: "GET",
    path: "/analytics",
  },
  sendFeedback: {
    method: "POST",
    path: "/feedbacks",
  },
};

export default analytics;
